import { SERVICES } from "@/lib/constants";
import Reveal from "@/components/Reveal";

export default function Services() {
  return (
    <div className="pt-28 pb-24 bg-brand-ivory">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <Reveal>
          <div className="text-center mb-14">
            <div className="divider-gold">Services</div>
            <h1 className="mt-4 font-serif text-5xl lg:text-6xl text-brand-navy">End-to-end property solutions</h1>
            <p className="mt-4 max-w-3xl mx-auto text-brand-charcoal/70">From sourcing verified properties to closing legal registration, we handle every step so you don't have to.</p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={i * 50}>
              <div className="bg-white border border-brand-gold/20 p-6 h-full hover:shadow-md hover:border-brand-gold transition-all">
                <div className="text-brand-gold font-serif text-4xl">0{i + 1}</div>
                <h3 className="mt-3 font-serif text-xl text-brand-navy">{s.title}</h3>
                <p className="mt-2 text-sm text-brand-charcoal/70">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
